/**
 * Creates an instance of FormField.
 * @typedef {Object} FormFieldOptionType
 * @property {string} displayText
 * @property {any} value
 */

/**
 * Represents a form field option.
 * @class
 */
export class FormFieldOption {
  /**
   * Create a new FormFieldOption.
   * @param {FormFieldOptionType} params
   */
  constructor(params) {
    this.displayText = params.displayText
    this.value = params.value
  }
}
